import React, { Component, Fragment } from "react";
import ReactTable from "react-table";
import { apiURL, apiPrefix } from "../../../utlis/config";
import moment from "moment";
import { Switch } from "antd";

import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
const formatTime = (date) => {
  date = moment(date).format("MMMM Do / YYYY, hh:mm A").split("/");
  return (
    <div>
      <p style={{ margin: 1 }}>{date[0]}</p>
      <p style={{ margin: 1 }}>{date[1]}</p>
    </div>
  );
};
export class Datatable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      checkedValues: [],
      myData: [],
      modalDelete: false,
    };
  }
  componentDidMount() {
    this.setState({
      checkedValues: [],
      myData: this.props.myData,
      modalDelete: false,
    });
    //console.log("------------", this.props);
  }

  selectRow = (e, i) => {
    if (!e.target.checked) {
      this.setState({
        checkedValues: this.state.checkedValues.filter((item, j) => i !== item),
      });
    } else {
      this.state.checkedValues.push(i);
      this.setState({
        checkedValues: this.state.checkedValues,
      });
    }
  };

  handleRemoveRow = () => {
    const { removeScanedEmail } = this.props;
    this.setState({ modalDelete: false });
    removeScanedEmail(this.state.checkedValues);
  };

  renderEditable = (cellInfo) => {
    return (
      <div
        style={{ backgroundColor: "#fafafa" }}
        contentEditable
        suppressContentEditableWarning
        onBlur={(e) => {
          const data = [...this.props.myData];
          data[cellInfo.index][cellInfo.column.id] = e.target.innerHTML;
          // this.setState({ myData: data });
        }}
        dangerouslySetInnerHTML={{
          __html: this.props.myData[cellInfo.index][cellInfo.column.id],
        }}
      />
    );
  };

  Capitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  render() {
    const {
      loading,
      pageSize,
      page,
      totalRecords,
      myClass,
      multiSelectOption,
      pagination,
      onChangePageSize,
      onChangePage,
      myData,
      bannerStatus,
      onEditInfo,
      onChangeActive,
    } = this.props;
    const columns = [
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Name
          </h6>
        ),
        accessor: "productId.name",
        Cell: null,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Sub-Title
      //     </h6>
      //   ),
      //   accessor: "subTitle",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Url
      //     </h6>
      //   ),
      //   accessor: "sUrl",
      //   Cell: null,
      //   style: {
      //     textAlign: "center",
      //   },
      // },
      {
        Header: (
          <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
            Date
          </h6>
        ),
        accessor: "createdAt",
        Cell: ({ value }) => {
          return <div>{formatTime(value)}</div>;
        },

        heigth: 40,
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Short Description
      //     </h6>
      //   ),
      //   accessor: "shortDescription",
      //   width: 200,
      //   Cell: ({ value }) => {
      //     return (
      //       <div
      //         style={{
      //           whiteSpace: "normal",
      //           textAlign: "justify",
      //         }}
      //       >
      //         {value}
      //       </div>
      //     );
      //   },
      //   style: {
      //     textAlign: "center",
      //   },
      // },

      {
        Header: (
          <h6
            style={{
              fontWeight: 600,
              margin: 0,
              letterSpacing: "0px",
              padding: "15px 10px"
            }}
          >
            Status
          </h6>
        ),
        accessor: "public",
        width: 100,
        Cell: ({ value, original, index }) => {
          console.log(index, !value, "original._id, !value");
          return (
            <div style={{}}>
              <Switch
                // loading={selectedIndex === index && loader ? true : false}
                defaultChecked={value}
                onChange={() => onChangeActive(original._id, !value, index)}
              />
            </div>
          );
        },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        },
      },
      // {
      //   Header: (
      //     <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px" }}>
      //       Status
      //     </h6>
      //   ),
      //   accessor: "active",
      //   width: 100,
      //   Cell: ({ value }) => {
      //     return (
      //       <div style={{}}>
      //         {value === 1 ? (
      //           <p
      //             style={{
      //               background: "green",
      //               borderRadius: "25px",
      //               color: "#ffffff",
      //               fontWeight: 600,
      //             }}
      //           >
      //             {"Activated"}
      //           </p>
      //         ) : (
      //           <p
      //             style={{
      //               background: "red",
      //               borderRadius: "25px",
      //               color: "#ffffff",
      //               fontWeight: 600,
      //             }}
      //           >
      //             {"Deactivated"}
      //           </p>
      //         )}
      //       </div>
      //     );
      //   },
      //   style: {
      //     textAlign: "center",
      //   },
      // },
    ];
    columns.push({
      Header: (
        <h6 style={{ fontWeight: 600, margin: 0, letterSpacing: "0px", padding: "15px 10px" }}>
          Action
        </h6>
      ),
      id: "delete",
      width: 100,
      accessor: (str) => "delete",
      Cell: ({ original, index }) => (
        <div>
          {/* {bannerStatus !== "deactivated" && (
            <span
              onClick={() => {
                //  this.setState({ modalDelete: true, dealerId: original._id });
              }}
              style={{ cursor: "pointer" }}
              title="Delete Banner"
            >
              <i
                className="fa fa-trash"
                style={{
                  width: 35,
                  fontSize: 20,
                  padding: 5,
                  color: "#e4566e",
                }}
              ></i>
            </span>
          )} */}
          <span
            onClick={() => {
              onEditInfo(index, original);
              //  this.setState({
              //    modalEdit: true,
              //    index: index,
              //    dealerId: original._id,
              //  });
            }}
            style={{ cursor: "pointer" }}
            title="Edit Banner Image"
          >
            <i
              className="bi bi-pencil-fill"
              style={{
                width: 35,
                fontSize: 20,
                padding: 5,
                color: "#1890ff",
              }}
            ></i>
          </span>
          {/* <span style={{ cursor: "pointer" }} title="View StaffMember info"><i className="fa fa-eye" style={{ width: 35, fontSize: 20, padding: 5, color: '#1890ff' }}></i></span> */}
        </div>
      ),
      style: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      },
      sortable: false,
    });
    return (
      <Fragment>
        <ReactTable
          manual
          data={myData}
          columns={columns}
          className={myClass}
          loading={loading}
          pages={totalRecords}
          page={page}
          pageSize={pageSize || 10}
          showPagination={pagination}
          onPageChange={(pageIndex) => onChangePage(pageIndex)}
          onPageSizeChange={(pageSize, pageIndex) =>
            // //console.log({ pageSize, pageIndex })
            onChangePageSize(pageSize)
          }
          showPagination={pagination}
          onFetchData={(state, instance) => console.log({ state, instance })}
          SubComponent={({ original }) => {
            console.log({ original });
            // var original = v.original;
            return (
              <div className="card m-3 p-4 border-0" style={{boxShadow:"1px 5px 24px 0 rgba(68, 102, 242, .05)"}}>
                <div className="card-header p-t-10 p-b-10" style={{background:"#ffff", borderBottom:"1px solid #f6f7fb"}}>
                  <div className="card-title fs-5 f-w-6">Banner Image</div>
                </div>
                <div className="card-body">
                  <img
                    className="imagePreview"
                    src={`${apiURL}${original.imageUrl}`}
                    alt="preview"
                  />
                </div>
              </div>
            );
            // <EmailBodyInfo index={v.row._index} myData={myData} />
          }}
        />
        {/* <ToastContainer /> */}
      </Fragment>
    );
  }
}

export default Datatable;
